export default __webpack_public_path__ + "static/media/church.622abe17.png";